import { Button, Center, Container, Stack, Text, Title } from "@mantine/core";
import {
  IconAlertCircle,
  IconExclamationMark,
  IconInfoCircle,
} from "@tabler/icons-react";

interface Props {
  title?: string;
  message: string;
  type?: "info" | "error" | "warning";
  actionButton?: {
    label: string;
    onClick: () => void;
    variant?: "filled" | "outline" | "light";
  };
  showIcon?: boolean;
}

function FullPageMessage({
  title,
  message,
  type = "info",
  actionButton,
  showIcon = true,
}: Props) {
  const getIcon = () => {
    switch (type) {
      case "error":
        return <IconAlertCircle size={48} color="var(--mantine-color-red-6)" />;
      case "warning":
        return (
          <IconExclamationMark
            size={48}
            color="var(--mantine-color-yellow-6)"
          />
        );
      default:
        return <IconInfoCircle size={48} color="var(--mantine-color-blue-6)" />;
    }
  };

  const getTitleColor = () => {
    switch (type) {
      case "error":
        return "red";
      case "warning":
        return "yellow";
      default:
        return "blue";
    }
  };

  return (
    <Container size="sm" style={{ minHeight: "60vh" }}>
      <Center style={{ minHeight: "60vh" }}>
        <Stack align="center" gap="lg">
          {showIcon && getIcon()}

          {title && (
            <Title order={2} ta="center" c={getTitleColor()}>
              {title}
            </Title>
          )}

          <Text size="lg" ta="center" c="dimmed" maw={500}>
            {message}
          </Text>

          {actionButton && (
            <Button
              variant={actionButton.variant || "filled"}
              onClick={actionButton.onClick}
              size="md"
            >
              {actionButton.label}
            </Button>
          )}
        </Stack>
      </Center>
    </Container>
  );
}

export default FullPageMessage;
